module.exports = __webpack_public_path__ + "img/07_03.8ca6530d.jpg";